import PrefixEnum from '../prefixes'

export default Object.freeze({
    'loveyourcurves.gymondo.fitness': PrefixEnum.ANDREA,
})
